import authFetch from '../utils/authFetch';

export const saveLineAllocation = async (orderItemId, allocationValue) => {
  if (!allocationValue) return;
  // Always PUT even for automatic mode — the user may have switched FROM supplier_specific
  // to automatic, and skipping the call would leave the old plan in the database.
  await authFetch(`/order_items/${orderItemId}/supplier-allocations`, {
    method: 'PUT', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      allocation_mode: allocationValue.mode,
      allocations: allocationValue.mode === 'supplier_specific'
        ? allocationValue.allocations.map(a => ({
            source_type:         a.source_type,
            supplier_id:         a.supplier_id || null,
            production_batch_id: a.production_batch_id || null,
            requested_quantity:  a.requested_quantity,
          }))
        : [],
    }),
  });
};
